import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    white-space: nowrap;
    overflow: hidden;

    @media (max-width: ${theme.screenSizes.laptop}) {
      &::before {
        content: '...';
        margin-top: 4px;
      }
    }
  `}
`

export const Content = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    margin-right: 6px;
    color: ${theme.colors.secondary};

    &:last-of-type {
      font-weight: 600;
      color: ${theme.colors.primary};
    }
  `}
`

export const Arrow = styled.span``
